"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _role = require("@/api/auth/role");
var _org = require("@/api/auth/org");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'roleIndex',
  directives: {
    waves: _waves.default
  },
  components: {
    SwPage: _SwPage.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: null,
      resTree: null,
      dialogResVisible: false,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 20,
        keywords: null
      },
      dialogFormVisible: false,
      dialogStatus: '',
      midData: {
        roleId: null,
        roleName: null,
        remark: null,
        type: null,
        defaultRule: false
      },
      textMap: {
        update: '编辑',
        create: '新建'
      },
      isUpdate: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentRoleId: '',
      rules: {
        roleName: [{
          required: true,
          message: '请填写名称',
          trigger: 'change'
        }]
      },
      sureFlag: true,
      //是否可编辑
      orgList: [],
      //组织列表
      sensitiveDataKey: [] //数据授权
    };
  },
  created: function created() {
    var orgQuery = sessionStorage.getItem('userBtns').includes('sysOrg:combobox');
    if (orgQuery) {
      console.log('orgQuery=' + orgQuery);
      this.getOrgList();
    }
    this.getList();
  },
  methods: {
    getOrgList: function getOrgList() {
      var _this = this;
      (0, _org.orgCombobox)().then(function (response) {
        if (response.data) {
          _this.orgList = response.data.records;
        }
      });
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _role.queryRolePage)(this.listQuery).then(function (response) {
        if (response) {
          _this2.list = response.records;
          _this2.total = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleCreate: function handleCreate() {
      var _this3 = this;
      this.resetMidData();
      this.dialogFormVisible = true;
      this.isUpdate = false;
      this.dialogStatus = 'create';
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this4 = this;
      this.resetMidData();
      this.dialogFormVisible = true;
      this.dialogStatus = 'update';
      this.$nextTick(function () {
        _this4.$refs['dataForm'].clearValidate();
      });
      this.isUpdate = true;
      // 获取角色详情
      (0, _role.getRoleById)(row.roleId).then(function (response) {
        var data = response.data;
        if (data) {
          _this4.midData.roleId = data.roleId;
          _this4.midData.roleName = data.roleName;
          _this4.midData.remark = data.remark;
          _this4.midData.type = data.type;
          _this4.midData.defaultRule = data.type == 2;
        }
      });
    },
    handleRoleRes: function handleRoleRes(row) {
      var _this5 = this;
      this.currentRoleId = row.roleId;
      //加载组织树
      var query = {
        "roleId": this.currentRoleId
      };
      // request -> /sysOrgRoleRes/list
      (0, _role.getRoleResTree)(query).then(function (response) {
        _this5.sureFlag = response.data.sureFlag;
        _this5.resTree = response.data.list;
        var checkedButton = response.data.buttonSelectedList;
        if (checkedButton != null && checkedButton.length > 0) {
          _this5.$refs.resTree.setCheckedKeys(checkedButton);
        } else {
          _this5.$refs.resTree.setCheckedKeys([]);
        }
      });
      this.dialogResVisible = true;
    },
    handleCheckBoxClick: function handleCheckBoxClick(data, checked, node) {},
    resetMidData: function resetMidData() {
      this.midData.roleId = null;
      this.midData.roleName = null;
      this.midData.remark = null;
      this.midData.defaultRule = false;
    },
    handleUpdateRoleRes: function handleUpdateRoleRes() {
      var _this6 = this;
      // 全选和半选的全部传给后台
      var checkedKeys = this.$refs.resTree.getCheckedKeys(false).concat(this.$refs.resTree.getHalfCheckedKeys());
      var roleResData = {
        roleId: this.currentRoleId,
        resIdSet: checkedKeys
      };
      console.log(roleResData);
      (0, _role.saveRoleRes)(roleResData).then(function () {
        _this6.dialogResVisible = false;
        _this6.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 3000
        });
      });
    },
    createData: function createData() {
      var _this7 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _role.createRole)(_this7.midData).then(function () {
            _this7.dialogFormVisible = false;
            _this7.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 3000
            });
            //重新加载数据
            _this7.getList();
          });
        }
      });
    },
    updateData: function updateData() {
      var _this8 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _role.updateRole)(_this8.midData).then(function () {
            _this8.dialogFormVisible = false;
            _this8.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 3000
            });
            //重新加载数据
            _this8.getList();
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this9 = this;
      (0, _role.deleteRole)(row.roleId).then(function () {
        _this9.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 3000
        });
        var index = _this9.list.indexOf(row);
        _this9.list.splice(index, 1);
      });
    }
  }
};